import styled from 'styled-components'
import { useForm } from "react-hook-form"
import { z } from 'zod'
import { zodResolver } from "@hookform/resolvers/zod"
import {
    Form,
    FormControl,
    FormDescription,
    FormField,
    FormItem,
    FormLabel,
    FormMessage,
} from "../../../ui/form"
import { Button } from '../../../ui/button'
import { Input } from '../../../ui/input'
import { Checkbox } from '../../../ui/checkbox'
import ProTableOt from '../../../utility/componentOt/views/ProtableOt'
import { useProTableOt } from '../../../utility/componentOt/controllers/ProtableOtController'
import { useNavigate, useParams } from 'react-router-dom'
import { Col, Row } from '../../../ui/RowCol'

import {useBorrower} from '../../controllers/BorrowerController'
import HoldFound from '../../components/HoldFoundModal'
import { useHold } from '../../controllers/HoldController'
import { useEffect } from 'react'
const setParamsFilter = (obj) => {
    return Object.entries(obj).reduce((all, [key, value]) => value === "" ? { ...all } : { ...all, [key]: value }, {})
}

const Holds = () => {
    const { itemnumber } = useParams()
    /* 設定form item的各欄位型態 */
    const formSchema = z.object({
        type: z.string(),
        keyword: z.string(),
    })
    /* 設定form item的各欄位預設值 */
    const form = useForm({
        resolver: zodResolver(formSchema),
        defaultValues: {
            type: "0",
            keyword: "",
        },
    })

    const onSubmit = (values) => {
        console.log('submit')
    }

    const navigate = useNavigate()
    const PatronsColumns = [
        {
            title: '名字',
            dataIndex: 'name',
            key: 'name',
            render: (text, record, index) => {
                console.log('record',record)
                return (
                    <>
                        {record?.firstname} {record?.middle_name} 
                    </>

                )
            }
        },
        {
            title: '卡號',
            dataIndex: 'cardnumber',
            key: 'cardnumber',
        },
        {
            title: '生日',
            dataIndex: 'dateofbirth',
            key: 'dateofbirth',
        },
        {
            title: '讀者類別',
            dataIndex: 'categoryname',
            key: 'categoryname',
        },
        {
            title: '所屬圖書館',
            dataIndex: 'branchname',
            key: 'branchname',
        },
        {
            title: '地址',
            dataIndex: 'address',
            key: 'address',
        },
        {
            title: '電話號碼',
            dataIndex: 'mobile',
            key: 'mobile',
        },
    ]
    const HoldsColumns = [
        {
            title: <><Checkbox /></>,
            dataIndex: 'item_itemnumber',
            key: 'item_itemnumber',
            render: (text, record, index) => {
                return (
                    <Checkbox />
                )
            }
        },
        {
            title: '順位',
            dataIndex: 'reserve_id',
            key: 'reserve_id',
            render: (text, record, index) => {               
                return (
                    <>
                        {record?.reserve?.reserve_id}
                    </>
                )
            }
        },
        {
            title: 'Button',
            dataIndex: 'Button',
            key: 'Button',
        },
        {
            title: '讀者',
            dataIndex: 'Patron',
            key: 'Patron',
            render: (text, record, index) => {
                return (
                    <>
                        {record?.reserve?.borrower_borrowernumber}
                    </>

                )
            }
        },
        {
            title: '註記',
            dataIndex: 'bibitem_notes',
            key: 'bibitem_notes',
        },
        {
            title: '時間',
            dataIndex: 'Date',
            key: 'Date',
        },
        {
            title: '期限',
            dataIndex: 'Expiration',
            key: 'Expiration',
        },
        {
            title: '借閱圖書館',
            dataIndex: 'PickupLibrary',
            key: 'PickupLibrary',
        },
        {
            title: '詳情',
            dataIndex: 'Details',
            key: 'Details',
        },
        {
            title: 'DOWN',
            dataIndex: 'DOWN',
            key: 'DOWN',
        },
        {
            title: 'Delet',
            dataIndex: 'Delet',
            key: 'Delet',
        },
        {
            title: '',
            dataIndex: 'Suspend',
            key: 'Suspend',
        },
        {
            title: '列印預約/轉館單',
            dataIndex: 'Print',
            key: 'Print',
        },
    ]

    const {
        HoldData,
        getHoldData,
        postHoldData,
        patchHoldData,
        deleteHoldData

    } = useHold({
        onBefore: () => { },
        onFinish: () => { }
    })
    const {
        check,
        setCheck,
        checkAll,
        setOrders,
        custom_filter_key,
        transferColumnAntdToShadcn,
        transferSortAntdToShadcn
    } = useProTableOt({
        PatronsColumns
    })


   
    const {
        BorrowerData,
        getBorrowerData
    } = useBorrower({
        onFinish: () => { },
        onBefore: () => { }
    })
    useEffect(()=>{
        console.log('BorrowerData',BorrowerData)
    },[BorrowerData])
   

    return (
        <MainContainer>
            <HoldFound />
            <Title>圖書預約</Title>
            <SubTitle>書名 by 作者</SubTitle>
            <WhiteBox>
                <SubTitle>搜尋讀者</SubTitle>
                <Form {...form}>
                    <form onSubmit={form.handleSubmit(onSubmit)}>
                        <div style={{ width: '100%', display: 'flex', gap: '0.5em' }}>
                            <div >
                                <FormField
                                    control={form.control}
                                    name="keyword"
                                    render={({ field }) => (
                                        <FormItem>
                                            <FormControl>
                                                <Input placeholder="搜尋館藏" {...field} />
                                            </FormControl>
                                            <FormMessage />
                                        </FormItem>
                                    )}
                                />
                            </div>
                            <div style={{ display: 'flex', justifyContent: 'center' }} >
                                <Button type="submit" >查詢</Button>
                            </div>
                        </div>
                    </form>
                </Form>
                <ProTableOt
                    // actionRef={actionRef}
                    columns={PatronsColumns}
                    request={async (params = {}, sort, filter) => {
                        // setAxiosMode("get")
                        let newParams = {
                        };
                        let order = setOrders(sort)
                        newParams = {
                            // ...params, //只有這個範例要有，其他請看你的後端要什麼資料
                            ...newParams,
                            order,
                            size: params.pageSize,
                            cur_page: params.current,
                            custom_filter_value: params.keyword ?? "",
                            custom_filter_key: custom_filter_key,
                            // "categorycode": "TEST",
                        };
                        newParams = setParamsFilter({
                            ...newParams,
                        });
                        // setPageSize(params?.pageSize ?? 20)
                        return getBorrowerData({
                            ...newParams
                        })
                    }}
                    rowSelection={false}
                />
            </WhiteBox>
            <WhiteBox>
                <SubTitle>已存在預約</SubTitle>
                <ProTableOt

                    columns={HoldsColumns}
                    request={async (params = {}, sort, filter) => {
                        // setAxiosMode("get")
                        let newParams = {
                        };
                        let order = setOrders(sort)
                        newParams = {
                            // ...params, //只有這個範例要有，其他請看你的後端要什麼資料
                            ...newParams,
                            order,
                            size: params.pageSize,
                            cur_page: params.current,
                            borrowernumber: "3",
                            cardnumber: "9235",
                            custom_filter_value: params.keyword ?? "",
                            custom_filter_key: custom_filter_key,
                            // "categorycode": "TEST",
                        };
                        newParams = setParamsFilter({
                            ...newParams,
                        });
                        // setPageSize(params?.pageSize ?? 20)
                        return getHoldData({
                            ...newParams
                        })
                    }}
                    rowSelection={false}
                />
            </WhiteBox>
        </MainContainer>
    )
}

const MainContainer = styled.div`
width: 100%;
display: flex;
-webkit-box-pack: center;
justify-content: space-around;
flex-direction: column;
-webkit-box-align: start;
align-items: start;
// padding: 2em;
gap: 0.5em;
-webkit-flex-wrap: wrap;
`

const LanContainer = styled.div`
width: 100%;
display: flex;
-webkit-box-pack: center;
justify-content: space-around;
flex-direction: row;
-webkit-box-align: start;
align-items: start;
gap: 0.5em;
flex-wrap: nowrap;
`

const VerContainer = styled.div`

width: 100%;
display: flex;
-webkit-box-pack: center;
justify-content: space-around;
flex-direction: column;
-webkit-box-align: start;
align-items: start;
gap: 0.5em;
flex-wrap: nowrap;
`

const SubTitle = styled.div`
text-align: left;
// width: 90%;
font-size: 1.1em;
font-weight: 600;
padding-bottom: 0.5em;
}
`

const ButtonGroup = styled.div`
width: 100%;
display: flex;
gap: 1em;
align-items: flex-start;
`
const WhiteBox = styled.div`
background-color: #fff;
padding: 1em;
width: -webkit-fill-available;
`
const GrayText = styled.span`
color: #929292;
`
const Title = styled.div`
text-align: left;
width: 90%;
font-size: 1.6em;
font-weight: 700;
}
`

const FlexBox = styled.div`
display: flex;
gap: 1em;
`

export default Holds